import { jsx } from 'panel';
import { DataTableEl } from 'common/components/data-table';
import { ODAControlEl } from 'common/widgets/oda-control';
import { ODA_FUNNELS_UPSELL_DESCRIPTION } from 'common/widgets/oda-control/constants'; // Warning: css selectors in this file are styled by mp-data-table
// TODO: remove this obscure linkage

export function template() {
  return jsx("div", {
    sel: '.table-wrapper'
  }, jsx("div", {
    sel: '.funnels-table'
  }, jsx(DataTableEl, {
    attrs: this.helpers.getDataTableAttrs(),
    props: {
      rows: this.helpers.getRows(),
      columnGroups: this.helpers.getColumns()
    },
    on: {
      selectionChange: this.helpers.onSelectionChange,
      sortChange: this.helpers.onSortChange
    }
  })), !this.attr("download-mode") ? jsx(ODAControlEl, {
    sel: '.oda-control',
    attrs: {
      description: "Receive an email with time comparison and interesting segments analysis for this funnel.",
      'is-waiting-for-schedule-analysis': this.attr("is-waiting-for-schedule-analysis"),
      'show-upsell': this.attr("show-on-demand-analysis-upsell"),
      'upsell-description': ODA_FUNNELS_UPSELL_DESCRIPTION
    },
    on: {
      clickAnalyze: this.helpers.clickAnalyze
    }
  }) : null);
}